// extracted by mini-css-extract-plugin
export default {"trades":"trades_trades__eq-KD","table":"trades_table__QggCo"};